import React from 'react';
import HeaderOne from "../components/header/HeaderOne";
import Breadcrumb from "./Breadcrumb";
import FooterOne from "../components/footer/FooterOne";

function TermsAndConditions() {
    const breadcrumbs = [
        { label: 'Home', link: '/' },
        { label: 'Terms & Conditions' }
    ];

    return (
        <div className=''>
            <HeaderOne />
            <Breadcrumb
                title="Terms & Conditions"
                breadcrumbs={breadcrumbs}
            />

            {/* Terms & Conditions Content Area */}
            <div className="rts-terms-area rts-section-gap">
                <div className="container">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="terms-content-wrapper">

                                {/* Introduction */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">1. Introduction</h3>
                                    <p>
                                        Welcome to Aviteus Business Solutions. These Terms and Conditions govern your use of our website and services.
                                        By accessing our website or engaging our services, you agree to be bound by these terms. If you do not agree
                                        with any part of these terms, please do not use our website or services.
                                    </p>
                                </div>

                                {/* Services */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">2. Our Services</h3>
                                    <p>
                                        Aviteus Business Solutions provides professional accounting, tax planning, business advisory, and related
                                        financial services to businesses and individuals. The scope of services will be defined in individual
                                        engagement letters or service agreements.
                                    </p>
                                    <ul className="terms-list mt--20">
                                        <li>All services are subject to availability and acceptance by Aviteus Business Solutions</li>
                                        <li>Service fees and payment terms will be outlined in your engagement letter</li>
                                        <li>We reserve the right to refuse service to any client at our discretion</li>
                                    </ul>
                                </div>

                                {/* Client Responsibilities */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">3. Client Responsibilities</h3>
                                    <p>As our client, you agree to:</p>
                                    <ul className="terms-list mt--20">
                                        <li>Provide accurate, complete, and timely information required for our services</li>
                                        <li>Respond promptly to our requests for information or clarification</li>
                                        <li>Maintain proper records and documentation as required by law</li>
                                        <li>Pay all fees in accordance with agreed payment terms</li>
                                        <li>Inform us immediately of any changes to your circumstances that may affect our services</li>
                                    </ul>
                                </div>

                                {/* Confidentiality */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">4. Confidentiality</h3>
                                    <p>
                                        We are committed to protecting the confidentiality of your information. All client information will be kept
                                        confidential and will only be disclosed where required by law or with your express permission. We maintain
                                        professional standards in accordance with relevant accounting bodies and data protection legislation.
                                    </p>
                                </div>

                                {/* Limitation of Liability */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">5. Limitation of Liability</h3>
                                    <p>
                                        While we strive to provide accurate and professional services, Aviteus Business Solutions shall not be liable for:
                                    </p>
                                    <ul className="terms-list mt--20">
                                        <li>Any losses arising from incomplete or inaccurate information provided by the client</li>
                                        <li>Losses resulting from circumstances beyond our reasonable control</li>
                                        <li>Indirect or consequential losses, unless caused by our negligence</li>
                                        <li>Decisions made by clients based on advice that was not formally documented</li>
                                    </ul>
                                    <p className="mt--20">
                                        Our liability is limited to the fees paid for the specific service in question, except in cases of proven
                                        negligence or breach of professional duty.
                                    </p>
                                </div>

                                {/* Intellectual Property */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">6. Intellectual Property</h3>
                                    <p>
                                        All content on this website, including text, graphics, logos, and software, is the property of Aviteus
                                        Business Solutions and is protected by intellectual property laws. You may not reproduce, distribute, or
                                        use any content without our prior written permission.
                                    </p>
                                </div>

                                {/* Termination */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">7. Termination of Services</h3>
                                    <p>
                                        Either party may terminate services with written notice as specified in the engagement letter. Upon
                                        termination, you remain responsible for payment of all fees for services rendered. We will return your
                                        records and documents upon settlement of outstanding fees.
                                    </p>
                                </div>

                                {/* Professional Standards */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">8. Professional Standards</h3>
                                    <p>
                                        Aviteus Business Solutions operates in accordance with professional standards set by relevant accounting
                                        and regulatory bodies. We maintain professional indemnity insurance and adhere to continuing professional
                                        development requirements.
                                    </p>
                                </div>

                                {/* Complaints */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">9. Complaints Procedure</h3>
                                    <p>
                                        If you have a complaint about our services, please contact us in writing at info@aviteusbusiness.co.uk.
                                        We will acknowledge your complaint within 5 business days and provide a full response within 28 days.
                                    </p>
                                </div>

                                {/* Changes to Terms */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">10. Changes to Terms</h3>
                                    <p>
                                        We reserve the right to modify these Terms and Conditions at any time. Changes will be posted on this page
                                        with an updated revision date. Your continued use of our services after changes are posted constitutes
                                        acceptance of the modified terms.
                                    </p>
                                </div>

                                {/* Governing Law */}
                                <div className="single-terms-section mb--40">
                                    <h3 className="title">11. Governing Law</h3>
                                    <p>
                                        These Terms and Conditions are governed by the laws of England and Wales. Any disputes arising from these
                                        terms or our services will be subject to the exclusive jurisdiction of the courts of England and Wales.
                                    </p>
                                </div>

                                {/* Contact Information */}
                                <div className="single-terms-section">
                                    <h3 className="title">12. Contact Information</h3>
                                    <p>
                                        If you have any questions about these Terms and Conditions, please contact us:
                                    </p>
                                    <div className="contact-info-terms mt--20">
                                        <p><strong>Aviteus Business Solutions</strong></p>
                                        <p>Alpha House, 296 Kenton Rd, Harrow HA3 8DD, United Kingdom</p>
                                        <p>Email: info@aviteusbusiness.co.uk</p>
                                        <p>Phone: 020 4628 8209</p>
                                    </div>
                                    <p className="mt--20">
                                        <strong>Last Updated: November 6, 2025</strong>
                                    </p>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </div>
            {/* Terms & Conditions Content Area End */}

            <FooterOne />
        </div>
    )
}

export default TermsAndConditions
